import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import parse from "html-react-parser";

import { getLabelMessage } from "../../../const/labelService";

import AppCard from "../../../components/shared/components/appCard/AppCard";

import Button from "../../../components/shared/components/button/Button.style";
import { ButtonContainer } from "../../settings/autoresponses/AutoResponses.style";
import { NewWhatsappTitle } from "../../settings/whatsappTemplates/whatsappTemplateMultimedia/whatsappTemplateMultimedia";
import {
  BackButton,
  BackButtonIcon,
  BackButtonIconContainer,
  BackButtonText,
} from "../../settings/whatsappTemplates/whatsappTemplats.style";
import backButtonIcon from "../../../assets/svg/KeyboardArrowLeft.svg";

import {
  BroadcastErrorCardContainer,
  ContentSpan,
  ExportIcon,
  ExportIconContainer,
  GridContainer,
  GridItem,
} from "./BroadcastView.styles";
import BroadcastAnalitycCard from "./BroadcastAnalitycsCard/BroadcastAnalitycCard.component";
import exportIcon from "../../../assets/svg/Publish.svg";
import { getCampaignStatus } from "../../../utils/campaign";
import { generarExcel } from "../../../utils/xlsxClass";
import moment from "moment";
import GeneralModal from "../../../components/shared/components/generalModal/GeneralModal.component";
import { setSelectedCampaignAction } from "../../../redux/campaignDuck";
import { useCampaignStatusActions } from "../../../hooks/useCampaignStatusActions";
import { useCampaignReschedule } from "../../../hooks/useCampaignReschedule";
import ResumeCampaignModal from "./ResumeCampaignModal.component";
import RescheduleCampaignModal from "./RescheduleCampaignModal.component";

// Statuses that allow pause and cancel
const PAUSABLE_STATUSES = new Set(["SCHEDULED", "IN_PROGRESS", "WAITING_FOR_APPROVAL_TEMPLATE"]);

const BroadcastAnalitycs = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedCampaign = useSelector(
    (state) => state.campaign?.selectedCampaign
  );
  const [campaignStatus, setCampaignStatus] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(true);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const labels = [
    "broadcastPreviewTitle",
    "variableInstructionsMessagePreview",
    "broadcastName",
    "whatsappTemplateName",
  ];
  const lbls = getLabelMessage(labels);

  const handleStatusSuccess = (newStatus) => {
    dispatch(setSelectedCampaignAction({ ...selectedCampaign, status: newStatus }));
  };

  const { changeStatus, isUpdating } = useCampaignStatusActions({
    onSuccess: handleStatusSuccess,
  });

  const handleRescheduleSuccess = (newSendAt) => {
    dispatch(setSelectedCampaignAction({ ...selectedCampaign, sendAt: newSendAt }));
  };

  const { reschedule, isRescheduling } = useCampaignReschedule({
    onSuccess: handleRescheduleSuccess,
  });

  const handleResumeClick = () => {
    const originalSendAt = selectedCampaign?.sendAt;
    const scheduleStillValid =
      originalSendAt && new Date(originalSendAt) > new Date();

    if (scheduleStillValid) {
      // Resume keeping the original schedule; without sendAt the backend anchors to "now"
      changeStatus("SCHEDULED", selectedCampaign?.id, {
        sendAt: moment(originalSendAt).format("YYYY-MM-DDTHH:mm:ss"),
      });
      return;
    }

    setIsResumeModalOpen(true);
  };

  const canPause = PAUSABLE_STATUSES.has(selectedCampaign?.status);
  const canResume = selectedCampaign?.status === "PAUSED";
  const canCancel = PAUSABLE_STATUSES.has(selectedCampaign?.status);
  const canReschedule = selectedCampaign?.status === "SCHEDULED";

  const handleActionButton = () => {
    generarExcel(
      selectedCampaign?.name,
      moment(selectedCampaign?.lastSendAt).format("DD/MM/YYYY"),
      campaignStatus
    );
    // history.push("/broadcast");
  };

  const getStatus = async () => {
    setIsLoading(true);
    const status = await getCampaignStatus(selectedCampaign?.id || "");
    console.log(status);
    setCampaignStatus(status);
    setIsLoading(false);
  };

  useEffect(() => {
    getStatus();
    // setError(status.error);
  }, []);

  return (
    <AppCard broadcastCard>
      <NewWhatsappTitle
        style={{ marginLeft: "0.875rem", fontSize: "1.5rem" }}
      >{`${selectedCampaign.name} - ${moment(selectedCampaign.createdAt).format(
        "DD/MM/YYYY"
      )} `}</NewWhatsappTitle>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(auto,1fr)",
          gridTemplateRows: "repeat(2, auto)",
          gridGap: "10px",
          marginTop: "10px",
          width: "90%",
        }}
      >
        <GridContainer>
          <GridItem>
            <BroadcastAnalitycCard
              count={campaignStatus?.successfulMessages?.length || 0}
              statusTitle="Mensajes enviados exitosamente"
              type="status"
              payload="success"
              isLoading={isLoading}
            />
          </GridItem>
          <GridItem>
            <BroadcastAnalitycCard
              count={campaignStatus?.sentdMessages?.length  || 0}
              statusTitle="Mensajes enviados, aún no recibidos por el cliente."
              type="status"
              payload="sent"
              isLoading={isLoading}
            />
            <BroadcastAnalitycCard
              count={campaignStatus?.deliveredMessages?.length  || 0}
              statusTitle="Mensajes recibidos, aún no leídos."
              type="status"
              payload="delivered"
              isLoading={isLoading}
            />
            <BroadcastAnalitycCard
              count={campaignStatus?.viewedMessages?.length  || 0}
              statusTitle="Mensaje leídos"
              type="status"
              payload="read"
              isLoading={isLoading}
            />
          </GridItem>
          <GridItem>
            <BroadcastAnalitycCard
              count={campaignStatus?.failedMessages?.length  || 0}
              statusTitle="Mensajes no enviados"
              type="error"
              payload="error"
              isLoading={isLoading}
            />
          </GridItem>
        </GridContainer>
      </div>

      <BackButton
        style={{
          marginTop: "10px",
          paddingTop: "30px",
          left: "0px",
        }}
        templateAction
        onClick={() => {
          history.push("/broadcast/table");
        }}
      >
        <BackButtonIconContainer>
          <BackButtonIcon src={backButtonIcon} />
        </BackButtonIconContainer>
        <BackButtonText>Regresar</BackButtonText>
      </BackButton>

      <ButtonContainer newTemplate templateMedia={true}>
        <Button designV4 onClick={handleActionButton}>
          Exportar
          <ExportIconContainer>
            <ExportIcon src={exportIcon} />
          </ExportIconContainer>
        </Button>

        {canPause && (
          <Button
            designV4
            disabled={isUpdating}
            onClick={() => changeStatus("PAUSED", selectedCampaign?.id)}
          >
            Pausar
          </Button>
        )}

        {canResume && (
          <Button designV4 disabled={isUpdating} onClick={handleResumeClick}>
            Reanudar
          </Button>
        )}

        {canReschedule && (
          <Button
            designV4
            disabled={isRescheduling}
            onClick={() => setIsRescheduleModalOpen(true)}
          >
            Reprogramar
          </Button>
        )}

        {canCancel && (
          <Button
            warning
            designV4
            disabled={isUpdating}
            onClick={() => setIsCancelModalOpen(true)}
          >
            Cancelar campaña
          </Button>
        )}
      </ButtonContainer>

      <GeneralModal
        type="general"
        mainText="¿Seguro que quieres cancelar esta campaña? Esta acción no se puede deshacer."
        show={isCancelModalOpen}
        confirmText="Cancelar campaña"
        cancelText="Volver"
        loadingForm={isUpdating}
        handleConfirmButton={async () => {
          const succeeded = await changeStatus("CANCELED", selectedCampaign?.id);
          if (succeeded) setIsCancelModalOpen(false);
        }}
        handleCancelButton={() => setIsCancelModalOpen(false)}
      />

      <ResumeCampaignModal
        show={isResumeModalOpen}
        isUpdating={isUpdating}
        onConfirm={async ({ sendAt }) => {
          const succeeded = await changeStatus("SCHEDULED", selectedCampaign?.id, {
            sendAt,
          });
          if (succeeded) setIsResumeModalOpen(false);
        }}
        onClose={() => setIsResumeModalOpen(false)}
      />

      <RescheduleCampaignModal
        show={isRescheduleModalOpen}
        isUpdating={isRescheduling}
        currentSendAt={selectedCampaign?.sendAt}
        onConfirm={async ({ sendAt }) => {
          const succeeded = await reschedule(selectedCampaign?.id, sendAt);
          if (succeeded) setIsRescheduleModalOpen(false);
        }}
        onClose={() => setIsRescheduleModalOpen(false)}
      />
    </AppCard>
  );
};

export default BroadcastAnalitycs;
